import request from "./request.service";

const getGeneral = async (consumer_id) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/balance?consumer_id=${consumer_id}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
const getItemCollect = async (consumer_id, offset = 0, limit = 10) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/quote/creation?consumer_id=${consumer_id}&offset=${offset}&limit=${limit}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
const getCoinCollect = async (consumer_id, offset = 0, limit = 10) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/coin/creation?consumer_id=${consumer_id}&offset=${offset}&limit=${limit}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
const getItemSpend = async (consumer_id, offset = 0, limit = 5) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/quote/spend?consumer_id=${consumer_id}&offset=${offset}&limit=${limit}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
const getCoinSpend = async (consumer_id, offset = 0, limit = 5) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/coin/spend?consumer_id=${consumer_id}&offset=${offset}&limit=${limit}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
const getPurchase = async (consumer_id, offset = 0, limit = 10) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/quote/purchase?consumer_id=${consumer_id}&offset=${offset}&limit=${limit}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
const getCoinPurchase = async (consumer_id, offset = 0, limit = 10) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/coin/purchase?consumer_id=${consumer_id}&offset=${offset}&limit=${limit}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
const giveCoin = async (consumer_id, name, receipt, type, description) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/coin?consumerId=${consumer_id}&name=${name}&type=${type}&uniq=${receipt}&description=${description}`,
      "POST"
    );
    // if (response.data.code != 200) {
    //   throw Error(response.data);
    // }
    return response.data;
  } catch (err) {
    throw err;
  }
};
const giveToken = async (consumer_id, name, receipt, type, description) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/quote?consumerId=${consumer_id}&name=${name}&type=${type}&uniq=${receipt}&description=${description}`,
      "POST"
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};
const getTypes = async () => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/report/crm/quote/types`
    );
    return response;
  } catch (err) {
    throw err;
  }
};
const getMission = async (consumer_id) => {
  try {
    const response = await request(
      `/campaign/lunar2025/v1/${consumer_id}/lunar/mission/mission_list`
    );
    return response;
  } catch (err) {
    throw err;
  }
};

export default {
  getGeneral,
  getItemCollect,
  getCoinCollect,
  getItemSpend,
  getCoinSpend,
  getPurchase,
  getCoinPurchase,
  giveCoin,
  giveToken,
  getTypes,
  getMission,
};
